/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type IgnoreUserInput = {
    readonly userID: string;
    readonly clientMutationId: string;
};
export type IgnoreUserMutationVariables = {
    readonly input: IgnoreUserInput;
};
export type IgnoreUserMutationResponse = {
    readonly ignoreUser: {
        readonly clientMutationId: string;
    };
};
export type IgnoreUserMutation = {
    readonly response: IgnoreUserMutationResponse;
    readonly variables: IgnoreUserMutationVariables;
};



/*
mutation IgnoreUserMutation(
  $input: IgnoreUserInput!
) {
  ignoreUser(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "IgnoreUserInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "ignoreUser",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "IgnoreUserPayload",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "clientMutationId",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "IgnoreUserMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "IgnoreUserMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "IgnoreUserMutation",
            "id": "16c2fa59c5737760b389dc3ba1f9a96d",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'cf86a39d13cf43c50b543ff8861c5373';
export default node;
